import { URLConfig } from "../network";
import { AgTechQueryParam } from "../enums";
import { Observable } from "rxjs";
import { helperFunctions } from "../helper";
import NetworkService from "../network/networkService";

export const getAttributes = (
    queryParams?: Array<{
      key: AgTechQueryParam;
      value: string[];
    }>
  ): Observable<any> => {
    let url = URLConfig.getAttributeURL();
    for (const param of queryParams || []) {
      url = helperFunctions.addQueryParam(url, param.key, param.value);
    }
    return new Observable((subscriber) => {
      NetworkService.get(url).then(
        (res: unknown) => {
          if (res) {
            const response = res as any;
            subscriber.next(response);
          }
          subscriber.complete();
        },
        (error: Error) => {
          subscriber.error(error);
          console.log("Error while fetching user data", error);
        }
      );
    });
  };
  